export default __webpack_public_path__ + "/dist/images/hat-icon.5e4bda751a21c2a92586077a3fbbf1b7.svg";